<template>
  <div class="container">
    <div class="save" @click="save">保存</div>
    <div id="tui-image-editor"></div>
  </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
 <script type="text/javascript" src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js"></script>

<script>
import "tui-image-editor/dist/tui-image-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
import Vue from "vue";
const ImageEditor = require("tui-image-editor");
const locale_zh = {
  // override default English locale to your custom
  Crop: "裁剪",
  DeleteAll: "全部删除",
  Delete: "删除",
  Undo: "撤销",
  Redo: "反撤销",
  Reset: "重置",
  Flip: "镜像",
  Rotate: "旋转",
  Draw: "画",
  Shape: "形状标注",
  Icon: "图标标注",
  Text: "文字标注",
  Mask: "遮罩",
  Filter: "滤镜",
  Bold: "加粗",
  Italic: "斜体",
  Underline: "下划线",
  Left: "左对齐",
  Center: "居中",
  Right: "右对齐",
  Color: "颜色",
  "Text size": "字体大小",
  Custom: "自定义",
  Square: "正方形",
  Apply: "应用",
  Cancel: "取消",
  "Flip X": "X 轴",
  "Flip Y": "Y 轴",
  Range: "区间",
  Stroke: "描边",
  Fill: "填充",
  Circle: "圆",
  Triangle: "三角",
  Rectangle: "矩形",
  Free: "曲线",
  Straight: "直线",
  Arrow: "箭头",
  "Arrow-2": "箭头2",
  "Arrow-3": "箭头3",
  "Star-1": "星星1",
  "Star-2": "星星2",
  Polygon: "多边形",
  Location: "定位",
  Heart: "心形",
  Bubble: "气泡",
  "Custom icon": "自定义图标",
  "Load Mask Image": "加载蒙层图片",
  Grayscale: "灰度",
  Blur: "模糊",
  Sharpen: "锐化",
  Emboss: "浮雕",
  "Remove White": "除去白色",
  Distance: "距离",
  Brightness: "亮度",
  Noise: "噪音",
  "Color Filter": "彩色滤镜",
  Sepia: "棕色",
  Sepia2: "棕色2",
  Invert: "负片",
  Pixelate: "像素化",
  Threshold: "阈值",
  Tint: "色调",
  Multiply: "正片叠底",
  Blend: "混合色",
  // etc...
};
const customTheme = {
  // image 坐上角度图片
  "common.bi.image": "https://uploadbeta.com/api/pictures/random/", // 在这里换上你喜欢的logo图片
  "common.bisize.width": "0px",
  "common.bisize.height": "0px",
  "common.backgroundImage": "none",
  "common.backgroundColor": "#f3f4f6",
  "common.border": "0px solid #444",

  // header
  "header.backgroundImage": "none",
  "header.backgroundColor": "#f3f4f6",
  "header.border": "0px",
  "header.display": "none",

  // load button
  "loadButton.backgroundColor": "#fff",
  "loadButton.border": "1px solid #ddd",
  "loadButton.color": "#222",
  "loadButton.fontFamily": "NotoSans, sans-serif",
  "loadButton.fontSize": "12px",
  "loadButton.display": "none", // 可以直接隐藏掉

  // download button
  "downloadButton.backgroundColor": "#fdba3b",
  "downloadButton.border": "1px solid #fdba3b",
  "downloadButton.color": "#fff",
  "downloadButton.fontFamily": "NotoSans, sans-serif",
  "downloadButton.fontSize": "12px",
  "downloadButton.display": "none", // 可以直接隐藏掉

  // icons default
  "menu.normalIcon.color": "#8a8a8a",
  "menu.activeIcon.color": "#555555",
  "menu.disabledIcon.color": "#434343",
  "menu.hoverIcon.color": "#e9e9e9",
  "submenu.normalIcon.color": "#8a8a8a",
  "submenu.activeIcon.color": "#e9e9e9",

  "menu.iconSize.width": "24px",
  "menu.iconSize.height": "24px",
  "submenu.iconSize.width": "32px",
  "submenu.iconSize.height": "32px",

  // submenu primary color
  "submenu.backgroundColor": "#1e1e1e",
  "submenu.partition.color": "#858585",

  // submenu labels
  "submenu.normalLabel.color": "#858585",
  "submenu.normalLabel.fontWeight": "lighter",
  "submenu.activeLabel.color": "#fff",
  "submenu.activeLabel.fontWeight": "lighter",

  // checkbox style
  "checkbox.border": "1px solid #ccc",
  "checkbox.backgroundColor": "#fff",

  // rango style
  "range.pointer.color": "#fff",
  "range.bar.color": "#666",
  "range.subbar.color": "#d1d1d1",

  "range.disabledPointer.color": "#414141",
  "range.disabledBar.color": "#282828",
  "range.disabledSubbar.color": "#414141",

  "range.value.color": "#fff",
  "range.value.fontWeight": "lighter",
  "range.value.fontSize": "11px",
  "range.value.border": "1px solid #353535",
  "range.value.backgroundColor": "#151515",
  "range.title.color": "#fff",
  "range.title.fontWeight": "lighter",

  // colorpicker style
  "colorpicker.button.border": "1px solid #1e1e1e",
  "colorpicker.title.color": "#fff",
};
export default {
  data() {
    return {
      instance: null,
      imgSrc: null,
      limitation:true
    };
  },
  created() {
    this.getQuery('url')
  },
  mounted() {
    this.instance = new ImageEditor(
      document.querySelector("#tui-image-editor"),
      {
        includeUI: {
          loadImage: {
            path: this.imgSrc,
            name: "image",
          },
          // initMenu: "draw",
          menuBarPosition: "bottom",
          locale: locale_zh,
          theme: customTheme,
        },
        cssMaxWidth: 350, // canvas 最大宽度
      }
    );
    this.$nextTick(() => {
      document.addEventListener("UniAppJSBridgeReady", function () {
      });
    });
  },
  methods: {
    //取url中的参数值
    getQuery(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        this.imgSrc = decodeURIComponent(r[2]);
      }
    },
    save() {
      if (this.limitation) {
        this.limitation = false
        let base64String = this.instance.toDataURL();
        // let data = base64String.split(",")[1]
        // let data1 = window.atob(base64String.split(",")[1]);
        uni.postMessage({
          data: {
            // imgData: data, 
            // imgData1: data1, 
            base64String:base64String
          }
        })
      }
    }
  },
};
</script>
<style lang="css" scoped>
.container {
  width: 100%;
  height: 100vh;
  text-align: center;
  background: #282828;
  position: relative;
  overflow: hidden;
}

.btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 10vh;
  margin-right: 40px;
}

.save {
  position: absolute;
  right: 10px;
  top: 14px;
  z-index: 99999;
  height: 28px;
  font-size: 12px;
  border-radius: 8px;
  background-color: #3C6DF8;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  font-weight: 500;
  padding: 0 10px;
}

::v-deep .tie-btn-resize {
  display: none !important;
}

::v-deep .tie-btn-crop {
  display: none !important;
}

::v-deep .tie-btn-flip {
  display: none !important;
}

::v-deep .tie-btn-rotate {
  display: none !important;
}

::v-deep .tie-btn-shape {
  display: none !important;
}

::v-deep .tie-btn-icon {
  display: none !important;
}

::v-deep .tie-btn-mask {
  display: none !important;
}

::v-deep .tie-btn-filter {
  display: none !important;
}

::v-deep .tie-btn-history {
  display: none !important;
}

::v-deep .tie-btn-zoomIn {
  display: none !important;
}

::v-deep .tie-btn-zoomOut {
  display: none !important;
}

::v-deep .tie-btn-hand {
  display: none !important;
}

::v-deep .tui-image-editor-icpartition {
  display: none !important;
}

::v-deep .tie-btn-delete {
  display: none !important;
}

::v-deep .tie-btn-deleteAll {
  display: none !important;
}

::v-deep .tui-image-editor-newline {
  display: none !important;
}

::v-deep .tui-image-editor-container .tui-image-editor-submenu {
  height: 100px !important;
}

::v-deep .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item .tui-image-editor-button{
  margin: 0 !important;
}

::v-deep .center{
  display: none !important;
}
::v-deep .color-picker-control{
  width: 148px !important;
  padding: 5px !important;
}
::v-deep .tui-image-editor-container div.tui-colorpicker-clearfix{
  display: none;
}
::v-deep .triangle{
  display: none;
}
</style>